import React from 'react';
const Contact = () => {
  return (
    <div className="contact-container">
      <h2 className="contact-title heading">Contact Us</h2>
      <p className="contact-text">
        Thank you for your interest in Janpravaha Social Foundation. Whether you’re looking to collaborate, support us, or need assistance, we’re here to listen and help.
      </p>

      <div className="contact-info">
        <p><strong>Email:</strong> <a href="mailto: janpravaha@gmail.com">janpravaha@gmail.com</a></p>
        <p><strong>Phone:</strong> <a href="tel:+917588346671">+91 7588346671</a></p>
        <p><strong>Address:</strong><br />
          SN 120A/120B, Sinhgad Rd, PL-27,<br />
          Sarita Elegance, Pune - 411030,<br />
          Maharashtra, India
        </p>
      </div>

      <div className="map-wrapper">
        <iframe
          title="location-map"
          src="https://maps.google.com/maps?q=Pune&t=&z=13&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="300"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
